import { dew as _getEnsAddressDew } from "../../actions/ens/getEnsAddress.js";
import { dew as _getEnsAvatarDew } from "../../actions/ens/getEnsAvatar.js";
import { dew as _getEnsNameDew } from "../../actions/ens/getEnsName.js";
import { dew as _getEnsResolverDew } from "../../actions/ens/getEnsResolver.js";
import { dew as _getEnsTextDew } from "../../actions/ens/getEnsText.js";
import { dew as _callDew } from "../../actions/public/call.js";
import { dew as _createBlockFilterDew } from "../../actions/public/createBlockFilter.js";
import { dew as _createContractEventFilterDew } from "../../actions/public/createContractEventFilter.js";
import { dew as _createEventFilterDew } from "../../actions/public/createEventFilter.js";
import { dew as _createPendingTransactionFilterDew } from "../../actions/public/createPendingTransactionFilter.js";
import { dew as _estimateContractGasDew } from "../../actions/public/estimateContractGas.js";
import { dew as _estimateFeesPerGasDew } from "../../actions/public/estimateFeesPerGas.js";
import { dew as _estimateGasDew } from "../../actions/public/estimateGas.js";
import { dew as _estimateMaxPriorityFeePerGasDew } from "../../actions/public/estimateMaxPriorityFeePerGas.js";
import { dew as _getBalanceDew } from "../../actions/public/getBalance.js";
import { dew as _getBlockDew } from "../../actions/public/getBlock.js";
import { dew as _getBlockNumberDew } from "../../actions/public/getBlockNumber.js";
import { dew as _getBlockTransactionCountDew } from "../../actions/public/getBlockTransactionCount.js";
import { dew as _getBytecodeDew } from "../../actions/public/getBytecode.js";
import { dew as _getChainIdDew } from "../../actions/public/getChainId.js";
import { dew as _getContractEventsDew } from "../../actions/public/getContractEvents.js";
import { dew as _getFeeHistoryDew } from "../../actions/public/getFeeHistory.js";
import { dew as _getFilterChangesDew } from "../../actions/public/getFilterChanges.js";
import { dew as _getFilterLogsDew } from "../../actions/public/getFilterLogs.js";
import { dew as _getGasPriceDew } from "../../actions/public/getGasPrice.js";
import { dew as _getLogsDew } from "../../actions/public/getLogs.js";
import { dew as _getProofDew } from "../../actions/public/getProof.js";
import { dew as _getStorageAtDew } from "../../actions/public/getStorageAt.js";
import { dew as _getTransactionDew } from "../../actions/public/getTransaction.js";
import { dew as _getTransactionConfirmationsDew } from "../../actions/public/getTransactionConfirmations.js";
import { dew as _getTransactionCountDew } from "../../actions/public/getTransactionCount.js";
import { dew as _getTransactionReceiptDew } from "../../actions/public/getTransactionReceipt.js";
import { dew as _multicallDew } from "../../actions/public/multicall.js";
import { dew as _readContractDew } from "../../actions/public/readContract.js";
import { dew as _simulateContractDew } from "../../actions/public/simulateContract.js";
import { dew as _uninstallFilterDew } from "../../actions/public/uninstallFilter.js";
import { dew as _verifyMessageDew } from "../../actions/public/verifyMessage.js";
import { dew as _verifyTypedDataDew } from "../../actions/public/verifyTypedData.js";
import { dew as _waitForTransactionReceiptDew } from "../../actions/public/waitForTransactionReceipt.js";
import { dew as _watchBlockNumberDew } from "../../actions/public/watchBlockNumber.js";
import { dew as _watchBlocksDew } from "../../actions/public/watchBlocks.js";
import { dew as _watchContractEventDew } from "../../actions/public/watchContractEvent.js";
import { dew as _watchEventDew } from "../../actions/public/watchEvent.js";
import { dew as _watchPendingTransactionsDew } from "../../actions/public/watchPendingTransactions.js";
import { dew as _prepareTransactionRequestDew } from "../../actions/wallet/prepareTransactionRequest.js";
import { dew as _sendRawTransactionDew } from "../../actions/wallet/sendRawTransaction.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.publicActions = void 0;
  const getEnsAddress_js_1 = _getEnsAddressDew();
  const getEnsAvatar_js_1 = _getEnsAvatarDew();
  const getEnsName_js_1 = _getEnsNameDew();
  const getEnsResolver_js_1 = _getEnsResolverDew();
  const getEnsText_js_1 = _getEnsTextDew();
  const call_js_1 = _callDew();
  const createBlockFilter_js_1 = _createBlockFilterDew();
  const createContractEventFilter_js_1 = _createContractEventFilterDew();
  const createEventFilter_js_1 = _createEventFilterDew();
  const createPendingTransactionFilter_js_1 = _createPendingTransactionFilterDew();
  const estimateContractGas_js_1 = _estimateContractGasDew();
  const estimateFeesPerGas_js_1 = _estimateFeesPerGasDew();
  const estimateGas_js_1 = _estimateGasDew();
  const estimateMaxPriorityFeePerGas_js_1 = _estimateMaxPriorityFeePerGasDew();
  const getBalance_js_1 = _getBalanceDew();
  const getBlock_js_1 = _getBlockDew();
  const getBlockNumber_js_1 = _getBlockNumberDew();
  const getBlockTransactionCount_js_1 = _getBlockTransactionCountDew();
  const getBytecode_js_1 = _getBytecodeDew();
  const getChainId_js_1 = _getChainIdDew();
  const getContractEvents_js_1 = _getContractEventsDew();
  const getFeeHistory_js_1 = _getFeeHistoryDew();
  const getFilterChanges_js_1 = _getFilterChangesDew();
  const getFilterLogs_js_1 = _getFilterLogsDew();
  const getGasPrice_js_1 = _getGasPriceDew();
  const getLogs_js_1 = _getLogsDew();
  const getProof_js_1 = _getProofDew();
  const getStorageAt_js_1 = _getStorageAtDew();
  const getTransaction_js_1 = _getTransactionDew();
  const getTransactionConfirmations_js_1 = _getTransactionConfirmationsDew();
  const getTransactionCount_js_1 = _getTransactionCountDew();
  const getTransactionReceipt_js_1 = _getTransactionReceiptDew();
  const multicall_js_1 = _multicallDew();
  const readContract_js_1 = _readContractDew();
  const simulateContract_js_1 = _simulateContractDew();
  const uninstallFilter_js_1 = _uninstallFilterDew();
  const verifyMessage_js_1 = _verifyMessageDew();
  const verifyTypedData_js_1 = _verifyTypedDataDew();
  const waitForTransactionReceipt_js_1 = _waitForTransactionReceiptDew();
  const watchBlockNumber_js_1 = _watchBlockNumberDew();
  const watchBlocks_js_1 = _watchBlocksDew();
  const watchContractEvent_js_1 = _watchContractEventDew();
  const watchEvent_js_1 = _watchEventDew();
  const watchPendingTransactions_js_1 = _watchPendingTransactionsDew();
  const prepareTransactionRequest_js_1 = _prepareTransactionRequestDew();
  const sendRawTransaction_js_1 = _sendRawTransactionDew();
  function publicActions(client) {
    return {
      call: args => (0, call_js_1.call)(client, args),
      createBlockFilter: () => (0, createBlockFilter_js_1.createBlockFilter)(client),
      createContractEventFilter: args => (0, createContractEventFilter_js_1.createContractEventFilter)(client, args),
      createEventFilter: args => (0, createEventFilter_js_1.createEventFilter)(client, args),
      createPendingTransactionFilter: () => (0, createPendingTransactionFilter_js_1.createPendingTransactionFilter)(client),
      estimateContractGas: args => (0, estimateContractGas_js_1.estimateContractGas)(client, args),
      estimateGas: args => (0, estimateGas_js_1.estimateGas)(client, args),
      getBalance: args => (0, getBalance_js_1.getBalance)(client, args),
      getBlock: args => (0, getBlock_js_1.getBlock)(client, args),
      getBlockNumber: args => (0, getBlockNumber_js_1.getBlockNumber)(client, args),
      getBlockTransactionCount: args => (0, getBlockTransactionCount_js_1.getBlockTransactionCount)(client, args),
      getBytecode: args => (0, getBytecode_js_1.getBytecode)(client, args),
      getChainId: () => (0, getChainId_js_1.getChainId)(client),
      getContractEvents: args => (0, getContractEvents_js_1.getContractEvents)(client, args),
      getEnsAddress: args => (0, getEnsAddress_js_1.getEnsAddress)(client, args),
      getEnsAvatar: args => (0, getEnsAvatar_js_1.getEnsAvatar)(client, args),
      getEnsName: args => (0, getEnsName_js_1.getEnsName)(client, args),
      getEnsResolver: args => (0, getEnsResolver_js_1.getEnsResolver)(client, args),
      getEnsText: args => (0, getEnsText_js_1.getEnsText)(client, args),
      getFeeHistory: args => (0, getFeeHistory_js_1.getFeeHistory)(client, args),
      estimateFeesPerGas: args => (0, estimateFeesPerGas_js_1.estimateFeesPerGas)(client, args),
      getFilterChanges: args => (0, getFilterChanges_js_1.getFilterChanges)(client, args),
      getFilterLogs: args => (0, getFilterLogs_js_1.getFilterLogs)(client, args),
      getGasPrice: () => (0, getGasPrice_js_1.getGasPrice)(client),
      getLogs: args => (0, getLogs_js_1.getLogs)(client, args),
      getProof: args => (0, getProof_js_1.getProof)(client, args),
      estimateMaxPriorityFeePerGas: args => (0, estimateMaxPriorityFeePerGas_js_1.estimateMaxPriorityFeePerGas)(client, args),
      getStorageAt: args => (0, getStorageAt_js_1.getStorageAt)(client, args),
      getTransaction: args => (0, getTransaction_js_1.getTransaction)(client, args),
      getTransactionConfirmations: args => (0, getTransactionConfirmations_js_1.getTransactionConfirmations)(client, args),
      getTransactionCount: args => (0, getTransactionCount_js_1.getTransactionCount)(client, args),
      getTransactionReceipt: args => (0, getTransactionReceipt_js_1.getTransactionReceipt)(client, args),
      multicall: args => (0, multicall_js_1.multicall)(client, args),
      prepareTransactionRequest: args => (0, prepareTransactionRequest_js_1.prepareTransactionRequest)(client, args),
      readContract: args => (0, readContract_js_1.readContract)(client, args),
      sendRawTransaction: args => (0, sendRawTransaction_js_1.sendRawTransaction)(client, args),
      simulateContract: args => (0, simulateContract_js_1.simulateContract)(client, args),
      verifyMessage: args => (0, verifyMessage_js_1.verifyMessage)(client, args),
      verifyTypedData: args => (0, verifyTypedData_js_1.verifyTypedData)(client, args),
      uninstallFilter: args => (0, uninstallFilter_js_1.uninstallFilter)(client, args),
      waitForTransactionReceipt: args => (0, waitForTransactionReceipt_js_1.waitForTransactionReceipt)(client, args),
      watchBlocks: args => (0, watchBlocks_js_1.watchBlocks)(client, args),
      watchBlockNumber: args => (0, watchBlockNumber_js_1.watchBlockNumber)(client, args),
      watchContractEvent: args => (0, watchContractEvent_js_1.watchContractEvent)(client, args),
      watchEvent: args => (0, watchEvent_js_1.watchEvent)(client, args),
      watchPendingTransactions: args => (0, watchPendingTransactions_js_1.watchPendingTransactions)(client, args)
    };
  }
  exports.publicActions = publicActions;
  //# sourceMappingURL=public.js.map
  return exports;
}